<div
  class="it-modal"
  [ngClass]="{ 'fullscreen-modal-mobile': modalConfig.fullScreenModalOnMobile }"
>
  <div
    #genericModal
    [ngClass]="modalConfig && modalConfig.id"
    class="modal fade"
    [attr.data-backdrop]="
      modalConfig && modalConfig.staticBackdrop ? 'static' : 'true'
    "
    [attr.data-keyboard]="
      modalConfig && modalConfig.keyboardActive
        ? modalConfig.keyboardActive
        : 'false'
    "
    [class.alert-modal]="modalConfig && modalConfig.type"
    [class.it-dialog-scrollable]="modalConfig && modalConfig.scrollable"
    tabindex="-1"
    [attr.role]="modalRole"
    [id]="modalConfig && modalConfig.id"
    [attr.aria-labelledby]="'modal2Title' + randomId"
  >
    <div
      class="modal-dialog"
      [ngClass]="
        modalConfig && modalConfig.size ? 'modal-' + modalConfig.size : ''
      "
      [ngStyle]="{
        width: modalConfig.customSize ? modalConfig.customSize + 'px' : '',
        'max-width': modalConfig.customSize ? 'unset' : ''
      }"
      role="document"
      cdkTrapFocus
    >
      <div
        class="modal-content"
        [ngStyle]="{
          width: modalConfig.customSize ? modalConfig.customSize + 'px' : '',
          height: modalConfig.heightBasedOnContent ? 'unset' : 'fit-content',
          'min-height': modalConfig.heightBasedOnContent ? '256px' : 'unset'
        }"
      >
        <div
          *ngIf="modalConfig.isDetailModal"
          class="modal-header custom-modal-header d-flex flex-row"
          [ngClass]="
            modalConfig && modalConfig.titleHeaderPosition
              ? 'align-items-' +
                modalConfig.titleHeaderPosition +
                ' align-content-' +
                modalConfig.titleHeaderPosition
              : 'align-items-center align-content-center'
          "
        >
          <div
            class="d-flex"
            [ngClass]="
              modalConfig && modalConfig.iconPosition
                ? 'align-items-' + modalConfig.iconPosition
                : 'align-items-center'
            "
          >
            <svg
              aria-hidden="true"
              class="icon d-none d-sm-block"
              *ngIf="modalConfig && modalConfig.needIcon"
              [ngClass]="{
                'icon-danger':
                  modalConfig.type == MessageManagerMessageTypeEnum.DANGER,
                'icon-warning':
                  modalConfig.type == MessageManagerMessageTypeEnum.WARNING,
                'icon-success':
                  modalConfig.type == MessageManagerMessageTypeEnum.SUCCESS,
                'icon-confirm':
                  modalConfig.type == MessageManagerMessageTypeEnum.CONFIRM
              }"
            >
              <use
                *ngIf="modalConfig.type == MessageManagerMessageTypeEnum.INFO"
                href="assets/sprite.svg#it-info-circle"
              ></use>
              <use
                *ngIf="modalConfig.type == MessageManagerMessageTypeEnum.DANGER"
                href="assets/sprite.svg#it-error"
              ></use>
              <use
                *ngIf="
                  modalConfig.type == MessageManagerMessageTypeEnum.WARNING
                "
                href="assets/sprite.svg#it-warning-circle"
              ></use>
              <use
                *ngIf="
                  modalConfig.type == MessageManagerMessageTypeEnum.SUCCESS
                "
                href="assets/sprite.svg#it-check-circle"
              ></use>
              <use
                *ngIf="
                  modalConfig.type == MessageManagerMessageTypeEnum.CONFIRM
                "
                href="assets/sprite.svg#it-help-circle"
              ></use>
            </svg>
            <span
              #modalTitleRef
              class="modal-title-detail"
              [attr.id]="'modal2Title' + randomId"
              >{{
                modalConfig && modalConfig.title!
                  ? (modalConfig.title! | translate : modalConfig.titleArgs)
                  : "-"
              }}</span
            >
          </div>
          <button
            [attr.title]="'CLOSE_WINDOW' | translate"
            (click)="closeModal(false)"
            *ngIf="
              modalConfig &&
              modalConfig.crossDismissable &&
              !modalConfig.crossDismissableListen
            "
            class="btn-close"
            type="button"
            tabindex="0"
          >
            <svg class="icon close" aria-hidden="true">
              <use href="assets/sprite.svg#it-close"></use>
            </svg>
            <span class="visually-hidden">{{
              "CLOSE_WINDOW" | translate
            }}</span>
          </button>
          <button
            [attr.title]="'CLOSE_WINDOW' | translate"
            (click)="modalConfig && modalConfig.onDismiss(true)"
            *ngIf="
              modalConfig &&
              modalConfig.crossDismissable &&
              modalConfig.crossDismissableListen &&
              modalConfig.onDismiss
            "
            class="btn-close"
            type="button"
            tabindex="0"
          >
            <svg class="icon close" aria-hidden="true">
              <use href="assets/sprite.svg#it-close"></use>
            </svg>
            <span class="visually-hidden">{{
              "CLOSE_WINDOW" | translate
            }}</span>
          </button>
        </div>

        <div
          *ngIf="!modalConfig.isDetailModal"
          class="modal-header custom-modal-header d-flex flex-row"
          [ngClass]="
            modalConfig && modalConfig.titleHeaderPosition
              ? 'align-items-' +
                modalConfig.titleHeaderPosition +
                ' align-content-' +
                modalConfig.titleHeaderPosition
              : 'align-items-center align-content-center'
          "
        >
          <div
            class="d-flex"
            [ngClass]="
              modalConfig && modalConfig.iconPosition
                ? 'align-items-' + modalConfig.iconPosition
                : 'align-items-center'
            "
          >
            <svg
              aria-hidden="true"
              class="icon d-none d-sm-block"
              *ngIf="modalConfig && modalConfig.needIcon"
              [ngClass]="{
                'icon-danger':
                  modalConfig.type == MessageManagerMessageTypeEnum.DANGER,
                'icon-warning':
                  modalConfig.type == MessageManagerMessageTypeEnum.WARNING,
                'icon-success':
                  modalConfig.type == MessageManagerMessageTypeEnum.SUCCESS,
                'icon-confirm':
                  modalConfig.type == MessageManagerMessageTypeEnum.CONFIRM
              }"
            >
              <use
                *ngIf="modalConfig.type == MessageManagerMessageTypeEnum.INFO"
                href="assets/sprite.svg#it-info-circle"
              ></use>
              <use
                *ngIf="modalConfig.type == MessageManagerMessageTypeEnum.DANGER"
                href="assets/sprite.svg#it-error"
              ></use>
              <use
                *ngIf="
                  modalConfig.type == MessageManagerMessageTypeEnum.WARNING
                "
                href="assets/sprite.svg#it-warning-circle"
              ></use>
              <use
                *ngIf="
                  modalConfig.type == MessageManagerMessageTypeEnum.SUCCESS
                "
                href="assets/sprite.svg#it-check-circle"
              ></use>
              <use
                *ngIf="
                  modalConfig.type == MessageManagerMessageTypeEnum.CONFIRM
                "
                href="assets/sprite.svg#it-help-circle"
              ></use>
            </svg>
            <h2
              #modalTitleRef
              class="modal-title-confirm m-0"
              [attr.id]="'modal2Title' + randomId"
            >
              {{
                modalConfig && modalConfig.title!
                  ? (modalConfig.title! | translate : modalConfig.titleArgs)
                  : "-"
              }}
            </h2>
          </div>
          <button
            [attr.title]="'CLOSE_WINDOW' | translate"
            (click)="closeModal(false)"
            *ngIf="
              modalConfig &&
              modalConfig.crossDismissable &&
              !modalConfig.crossDismissableListen
            "
            class="btn-close"
            type="button"
            tabindex="-1"
          >
            <svg class="icon close" aria-hidden="true">
              <use href="assets/sprite.svg#it-close"></use>
            </svg>
            <span class="visually-hidden">{{
              "CLOSE_WINDOW" | translate
            }}</span>
          </button>
          <button
            [attr.title]="'CLOSE_WINDOW' | translate"
            (click)="modalConfig && modalConfig.onDismiss(true)"
            *ngIf="
              modalConfig &&
              modalConfig.crossDismissable &&
              modalConfig.crossDismissableListen &&
              modalConfig.onDismiss
            "
            class="btn-close"
            type="button"
            tabindex="-1"
          >
            <svg class="icon close" aria-hidden="true">
              <use href="assets/sprite.svg#it-close"></use>
            </svg>
            <span class="visually-hidden">{{
              "CLOSE_WINDOW" | translate
            }}</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="col" *ngIf="modalConfig && modalConfig.message">
            <span
              *ngIf="modalConfig.messageFontSize"
              [ngStyle]="{ 'font-size': modalConfig.messageFontSize }"
              [innerHTML]="
                modalConfig.message!
                  | translate : modalConfig.messageArgs
                  | sanitizer : 'html'
              "
            ></span>
            <span
              *ngIf="!modalConfig.messageFontSize"
              [innerHTML]="
                modalConfig.message!
                  | translate : modalConfig.messageArgs
                  | sanitizer : 'html'
              "
            ></span>
          </div>
          <div
            class="modal-message-content mt-3"
            *ngIf="modalConfig && modalConfig.subMessage"
          >
            <span
              [innerHTML]="
                modalConfig.subMessage! | translate | sanitizer : 'html'
              "
            ></span>
          </div>
          <ng-content select="[customContent]"></ng-content>
        </div>

        <div
          *ngIf="!modalConfig.isDetailModal"
          class="modal-footer mt-3"
          [ngClass]="{ 'on-right': modalConfig.buttonsOnRight }"
        >
          <ng-container *ngIf="!modalConfig.closeBtnOnRight; else invertedBtns">
            <ng-container *ngTemplateOutlet="closeBtnTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="dismissBtnTemplate"></ng-container>
          </ng-container>

          <ng-template #invertedBtns>
            <ng-container *ngTemplateOutlet="dismissBtnTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="closeBtnTemplate"></ng-container>
          </ng-template>

          <ng-template #closeBtnTemplate>
            <button
              *ngIf="
                (modalConfig &&
                  modalConfig.onCloseBtnLabel &&
                  modalConfig.confirm &&
                  modalConfig.onClose) ||
                (modalConfig &&
                  !modalConfig.confirm &&
                  modalConfig.onClose &&
                  modalConfig.onCloseBtnLabel)
              "
              (click)="modalConfig.onClose(true)"
              class="btn btn-primary btn-lg col-12 col-md-auto"
              [ngClass]="{
                'btn-primary': !modalConfig.isCloseBtnDanger,
                'btn-danger': modalConfig.isCloseBtnDanger
              }"
              type="button"
              [disabled]="modalConfig.closeBtnDisabled"
              [style]="modalConfig.onCloseBtnStyle"
            >
              {{ modalConfig.onCloseBtnLabel! | translate }}
            </button>
          </ng-template>
          <ng-template #dismissBtnTemplate>
            <button
              *ngIf="
                modalConfig && modalConfig.confirm && modalConfig.onDismiss
              "
              (click)="modalConfig.onDismiss(false)"
              class="btn btn-outline-primary btn-lg col-12 col-md-auto"
              type="button"
            >
              {{ modalConfig.onDismissBtnLabel! | translate }}
            </button>
          </ng-template>
        </div>

        <div
          *ngIf="modalConfig.isDetailModal"
          class="modal-footer mt-3"
          [ngClass]="{ 'on-right': modalConfig.buttonsOnRight }"
        >
          <button
            *ngIf="modalConfig && modalConfig.onDismiss"
            (click)="modalConfig.onDismiss(false)"
            class="btn btn-primary btn-sm button-footer"
            [ngClass]="
              modalConfig && modalConfig.onCloseBtnStyle
                ? 'onCloseBtnStyle'
                : ''
            "
            type="button"
          >
            {{ modalConfig.onDismissBtnLabel! | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
